import { Button, ButtonProps } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type SttButtonUnsubscribeProps = {
    onClick: () => void;
} & ButtonProps;

/**
 * Unsubscribe button
 */
export function SttButtonUnsubscribe({
    onClick,
    ...rest
}: SttButtonUnsubscribeProps) {
    const { t } = useTranslation();

    return (
        <Button
            {...rest}
            variant="contained"
            color="secondary"
            className="button-delete"
            startIcon={<Cancel />}
            onClick={onClick}
        >
            {t('Unsubscribe')}
        </Button>
    );
}
